import NavSideBar from "../component/NavSideBar";

export default function Settings() {
  return (
    <NavSideBar>
            <div className="p-10 text-3xl font-bold">Settings</div>

    </NavSideBar>
  )
}
